
export var ProjectData = [
  {
    "title": "Project Title 7",
    "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    "client": "Ruby Clinton",
    "technologies": "iOS, HTML5, CSS3, PHP, Java",
    "industry": "Art & Design",
    "date": "July 16, 2019",
    "category": "Develop",
    "siteName": "CSE_CAREER",
    "url": {
      "name": "www.example.com",
      "link": "http://csecareer.com"
    },
    "socialLinks": {
      "facebook": "http://www.facebook.com/",
      "twitter": "http://www.twitter.com/",
      "google": "http://www.google.com/",
      "instagram": "http://www.instagram.com/",
      "mail": "mailto:example@gmail.com"
    },
    "thumbImage": "https://i.ibb.co.com/WW5vGNL/csecareer-2024.png",
    "sliderImages": [
      "images/projects/project-1.jpg",
      "images/projects/project-5.jpg"
    ]
  },

  {
    "title": "Project Title 5",
    "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    "client": "Ruby Clinton",
    "technologies": "iOS, HTML5, CSS3, PHP, Java",
    "industry": "Art & Design",
    "date": "July 16, 2019",
    "category": "Develop",
    "siteName": "Restaurant",
    "url": {
      "name": "www.example.com",
      "link": "https://restaurant-32683.web.app"
    },
    "socialLinks": {
      "facebook": "http://www.facebook.com/",
      "twitter": "http://www.twitter.com/",
      "google": "http://www.google.com/",
      "instagram": "http://www.instagram.com/",
      "mail": "mailto:example@gmail.com"
    },
    "thumbImage": "https://i.ibb.co/r2gHD4t/restaurant.png",
    "sliderImages": [
      "images/projects/project-1.jpg",
      "images/projects/project-5.jpg"
    ]
  },
{
    "title": "Project Title 6",
    "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    "client": "Ruby Clinton",
    "technologies": "iOS, HTML5, CSS3, PHP, Java",
    "industry": "Art & Design",
    "date": "July 16, 2019",
    "category": "Develop",
    "siteName": "Car-Doctor",
    "url": {
      "name": "www.example.com",
      "link": "https://cars-doctor-e47c4.web.app"
    },
    "socialLinks": {
      "facebook": "http://www.facebook.com/",
      "twitter": "http://www.twitter.com/",
      "google": "http://www.google.com/",
      "instagram": "http://www.instagram.com/",
      "mail": "mailto:example@gmail.com"
    },
    "thumbImage": "https://i.ibb.co/MkpLgFx/car.png",
    "sliderImages": [
      "images/projects/project-1.jpg",
      "images/projects/project-5.jpg"
    ]
  },
  
    {
        "title": "Project Title 1",
        "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
        "client": "Ruby Clinton",
        "technologies": "iOS, HTML5, CSS3, PHP, Java",
        "industry": "Art & Design",
        "date": "July 16, 2019",
        "category": "Design",
        "siteName": "BitCoin",
        "url": {
          "name": "www.example.com",
          "link": "https://mahmudul607.github.io/BdBitCoin"
        },
        "socialLinks": {
          "facebook": "http://www.facebook.com/",
          "twitter": "http://www.twitter.com/",
          "google": "http://www.google.com/",
          "instagram": "http://www.instagram.com/",
          "mail": "mailto:example@gmail.com"
        },
        "thumbImage":"https://i.ibb.co/X37xqMf/screencapture-mahmudul607-github-io-Bd-Bit-Coin-index-html-2023-10-25-12-26-03.png",
          "sliderImages": [
          "images/Project-1.PNG",
          "images/Project-2.PNG"
        ]
      },
    {
        "title": "Project Title 2",
        "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
        "client": "Ruby Clinton",
        "technologies": "iOS, HTML5, CSS3, PHP, Java",
        "industry": "Art & Design",
        "date": "July 16, 2019",
        "category": "Design",
        "siteName": "BdSoftonic",
        "url": {
          "name": "www.example.com",
          "link": "https://mahmudul607.github.io/BdSoftonic"
        },
        "socialLinks": {
          "facebook": "http://www.facebook.com/",
          "twitter": "http://www.twitter.com/",
          "google": "http://www.google.com/",
          "instagram": "http://www.instagram.com/",
          "mail": "mailto:example@gmail.com"
        },
        "thumbImage": "https://i.ibb.co/FVB53dG/screencapture-mahmudul607-github-io-Bd-Softonic-2023-10-25-12-32-04.png",
        "sliderImages": [
          "images/Project-2.PNG",
          "images/Project-8.PNG"
        ]
      },
    {
        "title": "Project Title 3",
        "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
        "client": "Ruby Clinton",
        "technologies": "iOS, HTML5, CSS3, PHP, Java",
        "industry": "Art & Design",
        "date": "July 16, 2019",
        "category": "Design",
        "siteName": "HappyDiagnostic",
        "url": {
          "name": "www.example.com",
          "link": "https://mahmudul607.github.io/happy-diagnostic-center"
        },
        "socialLinks": {
          "facebook": "http://www.facebook.com/",
          "twitter": "http://www.twitter.com/",
          "google": "http://www.google.com/",
          "instagram": "http://www.instagram.com/",
          "mail": "mailto:example@gmail.com"
        },
        "thumbImage": "https://i.ibb.co/QmCtDp9/Happy-Diagnostic.png",
        "sliderImages": [
          "images/projects/project-1.jpg",
          "images/projects/project-5.jpg"
        ]
      },
    {
        "title": "Project Title 4",
        "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
        "client": "Ruby Clinton",
        "technologies": "iOS, HTML5, CSS3, PHP, Java",
        "industry": "Art & Design",
        "date": "July 16, 2019",
        "category": "Develop",
        "siteName": "BitCoin",
        "url": {
          "name": "www.example.com",
          "link": "https://www.example.com"
        },
        "socialLinks": {
          "facebook": "http://www.facebook.com/",
          "twitter": "http://www.twitter.com/",
          "google": "http://www.google.com/",
          "instagram": "http://www.instagram.com/",
          "mail": "mailto:example@gmail.com"
        },
        "thumbImage": "https://i.ibb.co/X37xqMf/screencapture-mahmudul607-github-io-Bd-Bit-Coin-index-html-2023-10-25-12-26-03.png",
        "sliderImages": [
          "images/projects/project-1.jpg",
          "images/projects/project-5.jpg"
        ]
      },
      {
        "title": "Project Title 8",
        "projectInfo": "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
        "client": "Ruby Clinton",
        "technologies": "iOS, HTML5, CSS3, PHP, Java",
        "industry": "Art & Design",
        "date": "July 16, 2019",
        "category": "Develop",
        "siteName": "TiktakTo_Customized",
        "url": {
          "name": "www.example.com",
          "link": "https://gameninesquare.netlify.app"
        },
        "socialLinks": {
          "facebook": "http://www.facebook.com/",
          "twitter": "http://www.twitter.com/",
          "google": "http://www.google.com/",
          "instagram": "http://www.instagram.com/",
          "mail": "mailto:example@gmail.com"
        },
        "thumbImage": "https://i.ibb.co.com/RyCRVY7/screencapture-gameninesquare-netlify-app-2024-10-16-15-37-27.png",
        "sliderImages": [
          "images/projects/project-1.jpg",
          "images/projects/project-5.jpg"
        ]
      },
    
  ];
